import { CSSProperties, MouseEvent } from 'react';
import Icon from './Icon';
import styles from './Chip.module.css';

export type ChipProps = {
  rotulo: string;
  icone?: string;
  /** Cor hex do dado (ex.: cor da categoria); vira fundo translúcido + texto. */
  cor?: string;
  ativo?: boolean;
  onClick?: () => void;
  onRemover?: () => void;
};

export default function Chip({ rotulo, icone, cor, ativo, onClick, onRemover }: ChipProps) {
  // cor+'1a' = alpha ~10% sobre o hex vindo do dado (cores de categoria).
  const estiloCor: CSSProperties | undefined =
    cor && !ativo ? { background: `${cor}1a`, color: cor, borderColor: 'transparent' } : undefined;

  const remover = (evento: MouseEvent<HTMLSpanElement>) => {
    evento.stopPropagation();
    onRemover?.();
  };

  return (
    <span
      className={`${styles.chip} ${ativo ? styles.ativo : ''} ${onClick ? styles.clicavel : ''}`}
      style={estiloCor}
      onClick={onClick}
    >
      {icone && <Icon nome={icone} tamanho={14} />}
      {rotulo}
      {onRemover && (
        <span className={styles.remover} onClick={remover} role="button" aria-label="Remover">
          <Icon nome="close" tamanho={12} />
        </span>
      )}
    </span>
  );
}
